var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface-alert-warning-triangle--frame-alert-warning-triangle-exclamation-caution",
    clipPath: "url(#clip0_28_293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0757 8.57144V13.7143",
    stroke: "#D0004B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0756 19.7143C12.5496 19.7143 12.9339 19.3305 12.9339 18.8571C12.9339 18.3838 12.5496 18 12.0756 18C11.6016 18 11.2173 18.3838 11.2173 18.8571C11.2173 19.3305 11.6016 19.7143 12.0756 19.7143Z",
    stroke: "#D0004B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.6034 1.80001C13.4593 1.51921 13.2405 1.28355 12.9709 1.119C12.7013 0.954443 12.3915 0.867371 12.0756 0.867371C11.7597 0.867371 11.4498 0.954443 11.1803 1.119C10.9107 1.28355 10.6919 1.51921 10.5478 1.80001L1.10648 20.6572C0.974803 20.9181 0.912109 21.2084 0.924356 21.5003C0.936603 21.7923 1.02338 22.0763 1.17646 22.3254C1.32953 22.5744 1.54382 22.7802 1.79896 22.9233C2.05411 23.0664 2.34164 23.142 2.63426 23.1429H21.5169C21.8095 23.142 22.0971 23.0664 22.3522 22.9233C22.6074 22.7802 22.8217 22.5744 22.9747 22.3254C23.1278 22.0763 23.2146 21.7923 23.2268 21.5003C23.2391 21.2084 23.1764 20.9181 23.0447 20.6572L13.6034 1.80001Z",
    stroke: "#D0004B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0325,
    height: 24,
    fill: "white",
    transform: "translate(0.0595703)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert.2c5ef5c34de1fa502e3120fb13e6bd05.svg";